var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"id":_vm.name},on:{"change":_vm.handleChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }